import styled from 'styled-components';
import { shape, string, bool } from 'prop-types';
import { C_SHADOW, C_LUNAR } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_TRPL, GEL_SPACING_QUAD, GEL_SPACING_QUIN } from '@bbc/gel-foundations/spacings';
import { getCanon, getTrafalgar } from '@bbc/gel-foundations/typography';
import { MEDIA_QUERY_TYPOGRAPHY } from '@bbc/gel-foundations/breakpoints';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { getSansBold, getSerifMedium } from '@bbc/psammead-styles/font-styles';
export var Headline = /*#__PURE__*/styled.h1.withConfig({
  displayName: "Headline",
  componentId: "sc-1kh1qhu-0"
})(["", ";", " color:", ";display:block;margin:0;padding:", " 0;", "{padding:", " 0;}"], function (_ref) {
  var script = _ref.script;
  return script && getCanon(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSerifMedium(service);
}, function (_ref3) {
  var darkMode = _ref3.darkMode;
  return darkMode ? C_LUNAR : C_SHADOW;
}, GEL_SPACING_QUAD, MEDIA_QUERY_TYPOGRAPHY.LAPTOP_AND_LARGER, GEL_SPACING_QUIN);
export var SubHeading = /*#__PURE__*/styled.h2.attrs(function () {
  return {
    tabIndex: '-1'
  };
}).withConfig({
  displayName: "SubHeading",
  componentId: "sc-1kh1qhu-1"
})(["", ";", " color:", ";margin:0;padding:", " 0;", "{padding-top:", ";}"], function (_ref4) {
  var script = _ref4.script;
  return script && getTrafalgar(script);
}, function (_ref5) {
  var service = _ref5.service;
  return getSansBold(service);
}, function (_ref6) {
  var darkMode = _ref6.darkMode;
  return darkMode ? C_LUNAR : C_SHADOW;
}, GEL_SPACING_TRPL, MEDIA_QUERY_TYPOGRAPHY.LAPTOP_AND_LARGER, GEL_SPACING_QUAD);
Headline.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  darkMode: bool
};
Headline.defaultProps = {
  darkMode: false
};
SubHeading.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  darkMode: bool
};
Headline.defaultProps = {
  darkMode: false
};